"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceProvider = void 0;
var _react = require("react");
var R = _interopRequireWildcard(require("ramda"));
var _reactRedux = require("react-redux");
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _price = require("../../../../../../helpers/price");
var _actions = require("../../store/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PriceProvider = exports.PriceProvider = function PriceProvider(_ref) {
  var children = _ref.children,
    currency = _ref.currency,
    byParamName = _ref.byParamName,
    byParamValue = _ref.byParamValue,
    offerID = _ref.offerID,
    queryID = _ref.queryID;
  var dispatch = (0, _reactRedux.useDispatch)();
  var offerSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getOffer)(), [{
      offerID: offerID,
      queryID: queryID
    }]);
  }, [offerID, queryID]);
  var offer = (0, _reactRedux.useSelector)(offerSelector);
  var handleClickByPrice = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.searchByParam)(byParamName, byParamValue, queryID));
  }, [byParamName, byParamValue, dispatch, queryID]);
  return children(offer ? (0, _price.preparePriceForRender)(offer.price[currency.code], currency.symbol) : undefined, handleClickByPrice);
};
PriceProvider.propTypes = {
  byParamName: _propTypes.default.oneOf([_fn.QUERY_PARAMS.OPERATORS, _fn.QUERY_PARAMS.CATEGORY, _fn.QUERY_PARAMS.DEPARTURES]).isRequired,
  byParamValue: _propTypes.default.any.isRequired,
  children: _propTypes.default.func.isRequired,
  currency: _propTypes.default.shape({
    code: _propTypes.default.string.isRequired,
    symbol: _propTypes.default.string.isRequired
  }).isRequired,
  offerID: _propTypes.default.string,
  queryID: _propTypes.default.string.isRequired
};